import React, { useState } from 'react';
import { saveAs } from './FileSaver';

const Api = require('./Config');

const DoctorAlertCSV = () => {
  const [isLoading, setIsLoading] = useState(false);

  const getAlerts = async () => {
    let alertItems = [];
    let alertCount = 0;
    let startIdx = 0;
    const queryAmount = 200;

    do {
      const results = await Api.getAlertForDoctor(startIdx, queryAmount);
      const currentAlerts = results.DATA;
      alertItems = alertItems.concat(currentAlerts);
      alertCount = currentAlerts.length;
      startIdx += alertCount;
    } while (alertCount > 0);

    return alertItems;
  };

  const doCsv = async () => {
    setIsLoading(true);

    const alerts = await getAlerts();
    let csv = 'Run Date,' + Api.getDateFormat(new Date(), false);
    csv += '\r\n';
    csv += '\r\n';

    const headings = ['Patient', 'T-Code', 'Journey', 'Missed Since', 'Last Alert Cleared'];

    csv += headings.join(',');
    csv += '\r\n';

    for (let counter = 0; counter < alerts.length; counter += 1) {
      const row = alerts[counter];
      const rowOutput = [
        row.patient_ref,
        row.t_code,
        row.journey_name,
        row.diff,
        Api.getDateFormat(row.last_alert_cleared_date, true),
      ];

      csv += rowOutput.join(',');
      csv += `\r\n`;
    }
    const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, `${new Date()} - noreplyalerts - report.csv`);
    setIsLoading(false);
  };

  return (
    <button onClick={doCsv} className="btn btn-primary" type="button" disabled={isLoading}>
      <i className="fa fa-download " style={{ marginRight: 5 }} />
      CSV
    </button>
  );
};

export default DoctorAlertCSV;
